/**
 * Every operable rail runs in exactly one country, so the availability views can pin a flag next to the rail
 * name. Mirrors the corridor catalog in coloca-nest (`supported-rails.constant.ts`); a rail added there later
 * simply renders without a flag until it is mapped here.
 */
export interface RailCountry {
  iso2: string;
  labelKey: "country_ar" | "country_br" | "country_co" | "country_mx";
}

export const RAIL_COUNTRY: Record<string, RailCountry> = {
  SPEI: { iso2: "MX", labelKey: "country_mx" },
  PIX: { iso2: "BR", labelKey: "country_br" },
  CBU_CVU: { iso2: "AR", labelKey: "country_ar" },
  BREB: { iso2: "CO", labelKey: "country_co" },
  TRANSFIYA: { iso2: "CO", labelKey: "country_co" },
  PSE: { iso2: "CO", labelKey: "country_co" },
  NEQUI: { iso2: "CO", labelKey: "country_co" },
  BANCOLOMBIA_BUTTON: { iso2: "CO", labelKey: "country_co" },
};
